import Service from '../abstract/service'

export default class Sincronizacao extends Service {
  constructor() {
    super()
    this._dataSyncRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/DataSync`
    )
  }

  async getAll() {
    try {
      this._loading.setLoading(true, 'Carregando dados')

      const response = await this._dataSyncRef.orderBy('dataCriacao', 'desc').limit(10).get()

      let sincronizacoes = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          sincronizacoes.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(sincronizacoes)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
